<template>
  <button class="Btn-Reaction" :class="get_activeClass">
    <img class="Btn-Reaction__icon" :src="icon" />
    <span class="Btn-Reaction__count" :style="get_minWidth" v-if="get_isShowCounter">
      <span ref="countInner" class="Btn-Reaction__count-inner">{{ currentCount }}</span>
    </span>
  </button>
</template>

<script setup>
  import { defineProps, computed, ref, watch } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  const countInner = ref(null);
  const currentCount = ref(props.count);
  const isIncreasing = ref(false);
  //--------------------------
  //Применить класс, если кнопка находится в положении Active
  const get_activeClass = computed(() => props.isActive ? 'Btn-Reaction--active' : '');
  //Отобразить счетчик
  const get_isShowCounter = computed(() => props.count > 0);
  //Получить минимальную ширину для счетчика
  const get_minWidth = computed(() => {
    if(props.count < 10) return 'min-width: 10px';
    else if(props.count > 11 && props.count < 100) return 'min-width: 20px';
    else return '';
  });
  //--------------------------
  //Запустить анимацию прокручивания
  const animateCounter = () => {
    currentCount.value = props.count;
    if(!countInner.value) return;
    const animationClass = isIncreasing.value ? 'Btn-Reaction__count--increase' : 'Btn-Reaction__count--decrease';
    countInner.value.classList.add(animationClass);
    countInner.value.addEventListener('animationend', () => {
      countInner.value.classList.remove(animationClass);
    },{ once: true });
  };
  //--------------------------
  watch(() => props.count, (newCount, oldCount) => {
    if (newCount !== oldCount) {
      isIncreasing.value = newCount > oldCount;
      animateCounter();
    }
  }
);
</script>

<style lang="scss">
  @import "./styles/_style";
</style>